<div class="row mx-0">
    <div class="col-12 px-0">
        <div class="container d-flex align-items-center justify-content-center">
            <img src="../../../../../assets/images/Oops! 404 Error.svg" width="40%" />
        </div>
    </div>
</div>